/**
 * TaskNotificationChannelService
 * Service for per-NotificationType channel toggle settings.
 * Route: api/tasks/notification-channels
 */
export class TaskNotificationChannelService {
    constructor(http, config) {
        this.http = http;
        this.basePath = config?.basePath ?? 'api/tasks/notification-channels';
        // Proxy routes /tasks/api/... to the TaskManagement microservice;
        // /api/... (no service prefix) returns 404 from the gateway.
        this.servicePath = config?.servicePath ?? 'tasks';
    }
    buildUrl(suffix = '') {
        const path = suffix
            ? `/${this.servicePath}/${this.basePath}/${suffix}`
            : `/${this.servicePath}/${this.basePath}`;
        return path.replace(/\/+/g, '/');
    }
    /** List all channel-setting rows (one per notification type). */
    async getAll() {
        const response = await this.http.get(this.buildUrl());
        return response.data ?? [];
    }
    async getAllRaw() {
        return this.http.get(this.buildUrl());
    }
    /**
     * Partial-update one row identified by NotificationTypeID.
     * Returns the updated row.
     */
    async updateChannel(notificationTypeId, patch) {
        const response = await this.http.put(this.buildUrl(String(notificationTypeId)), patch);
        return response.data;
    }
    async updateChannelRaw(notificationTypeId, patch) {
        return this.http.put(this.buildUrl(String(notificationTypeId)), patch);
    }
}
//# sourceMappingURL=TaskNotificationChannelService.js.map